import {React, clickOn, _n, _s} from 'pexui';
import * as utils from '../../utilities/utils';
import * as consts from '../../models/consts';
import {showSpinner, hideSpinner} from './spinner';

function cancelClickEvent(evt) {
    if (evt.stopPropagation) {
        evt.stopPropagation();
    } else {
        evt.cancelBubble = true; //IE
    }
}

export function startBusy(elemOrId){
    let busyZone = 'widget';
    if(elemOrId){
        const elem = utils.getElement(elemOrId);
        if(elem){
            showSpinner(elem, {mode:'embedded'});

            busyZone = elem.getAttribute('data-busyZone');
        }
    }
    const elemZone = findZoneElement(busyZone);

    if(elemZone){
        elemZone.addEventListener('click', cancelClickEvent, true); // swallowing the event in capturing phase can effectly disable it.

        goOverInputs(elemZone, elemInZone=>{
            const activeWhenBusy = elemInZone.getAttribute('data-activeWhenBusy');
            const preDisabled = elemInZone.getAttribute('data-preDisabled');
            if(!preDisabled && !(activeWhenBusy && (
                    activeWhenBusy === '*' || 
                    activeWhenBusy === 'true' || 
                    activeWhenBusy === busyZone))){

                elemInZone.setAttribute('data-preDisabled', elemInZone.disabled? 'true': 'false');
                elemInZone.disabled = true;
            }
        });
    }
}

export function stopBusy(elemOrId){
    let busyZone = 'widget';
    if(elemOrId){
        const elem = utils.getElement(elemOrId);
        if(elem){
            hideSpinner(elem);
            busyZone = elem.getAttribute('data-busyZone');
        }
    }
    const elemZone = findZoneElement(busyZone);

    if(elemZone){
        elemZone.removeEventListener('click', cancelClickEvent, true);

        goOverInputs(elemZone, elemInZone=>{
            const savedText = elemInZone.getAttribute('data-text');
            if(savedText){
                hideSpinner(elemInZone);
            }

            const preDisabled = elemInZone.getAttribute('data-preDisabled');
            if(preDisabled){
                elemInZone.disabled = preDisabled === 'true';
                elemInZone.removeAttribute('data-preDisabled');
            }else if(elemInZone.disabled){
                elemInZone.disabled = false;
            }
        });
    }
}

function findZoneElement(zone){
    let elemZone = null;
    if((!zone) || zone === '*' || zone === 'widget'){
        elemZone = document.getElementById(consts.ELEM_ID_WIDGET);
    }else if(zone === 'page' || zone === 'body'){
        elemZone = document.body;
    }else{
        elemZone = document.getElementById(zone);
    }
    return elemZone;
}

function goOverInputs(elemZone, cb){
    let elems = elemZone.getElementsByTagName('button');
    for(let i=0;i<elems.length;i++){
        cb(elems.item(i));
    }
    elems = elemZone.getElementsByTagName('a');
    for(let i=0;i<elems.length;i++){
        cb(elems.item(i));
    }
    elems = elemZone.getElementsByTagName('input');
    for(let i=0;i<elems.length;i++){
        const e = elems.item(i);
        if(e.getAttribute('type') !== 'file' && e.getAttribute('type') !== 'hidden'){
            cb(e);
        }
    }
}



// WEBPACK FOOTER //
// ./application/src/views/comps/busy.jsx